import { phxBrowserDetectDelegate } from 'ui-ng-browser-detect';

interface IAppStoreConfig {
  appName: string;
  appStoreLink: string;
  appStoreText: string;
}

export class AppStoreBannerController {
  appStoreConfig: IAppStoreConfig;
  isMobile: boolean;
  showBanner: boolean = false;
  browserName: string = 'Web Browser';
  showCheckSettingsNotice: boolean = false;
  constructor(
    private appConfigModel: any,
    private ngDeeplinkConfig: any,
    private ngBrowserDetectDelegate: phxBrowserDetectDelegate
  ) {
    let appStoreLink = 'http://guide.app.link';
    const deepLink = this.ngDeeplinkConfig.getOriginalDeeplink();
    if (deepLink) {
      appStoreLink = `${appStoreLink}/app/${deepLink.split('app/')[1]}`;
    }
    this.isMobile = this.isMobileDevice();
    this.appStoreConfig = {
      appName: 'Navigate360',
      appStoreLink,
      appStoreText: 'For an optimized mobile experience, please view your school account in our mobile app'
    };
    this.browserName = this.ngBrowserDetectDelegate.getBrowserName();
    this.showBanner = this.isMobile;
    this.showCheckSettingsNotice = appStoreLink.includes('/dl/apt?pal_guid') && this.isAndroid();
    this.checkDefaults();
  }

  isMobileDevice() {
    return typeof window.orientation !== 'undefined';
  }

  isAndroid() {
    return window.navigator.userAgent.includes('Android');
  }

  openMobileApp() {
    window.location.assign(this.appStoreConfig.appStoreLink);
  }

  continueToWebApp() {
    this.showBanner = false;
  }

  checkDefaults() {
    const changeBrowserText = ' and set your default browser to ';
    if (this.isAndroid() && this.browserName !== 'Chrome') {
      this.appStoreConfig.appStoreText = this.appStoreConfig.appStoreText + changeBrowserText + 'Chrome.';
    } else if (!this.isAndroid() && this.browserName !== 'Safari') {
      this.appStoreConfig.appStoreText = this.appStoreConfig.appStoreText + changeBrowserText + 'Safari.';
    } else {
      this.appStoreConfig.appStoreText = this.appStoreConfig.appStoreText + '.';
    }
  }
}

export class AppStoreBannerComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/appstore_banner/app_store_banner.html';
  public controller: any = AppStoreBannerController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/lib/appstore_banner/app_store_banner.ts